import { Grid } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const ROW_HEIGHT = 36;
export const ROW_MARGIN_BOTTOM = 10;

export function getSimpleAudioBarHeight() {
  return ROW_HEIGHT + ROW_MARGIN_BOTTOM;
}

const THUMB_BOTTOM_OFFSET = 11;

export function getRichAudioBarThumbHeight(speakerSize: number) {
  return speakerSize * ROW_HEIGHT + THUMB_BOTTOM_OFFSET;
}

export function getRichAudioBarHeight(speakerSize: number) {
  return ROW_HEIGHT + getRichAudioBarThumbHeight(speakerSize);
}

export const AudioBarGrid = styled(Grid)`
  grid-template-columns: 50px 1fr 50px;
  margin-top: ${ROW_MARGIN_BOTTOM}px;
  width: 100%;
  column-gap: 24px;
  align-items: center;
  grid-auto-rows: ${ROW_HEIGHT}px;
  transition: grid-auto-rows 0.3s ease;
`;
